import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { BsEye } from 'react-icons/bs';
import { Button } from 'react-bootstrap';
import Nav from '../../../Components/base/nav';
import RichTextEditor from '../../../Components/RichTextEditor'; // Ensure this import is correct
import ChooseImage from '../../../Components/Modal/ChooseImage';
import ActionBar from '../../../Components/Button/ActionBar';
import GalleryForm from '../../../Components/Forms/GalleryForm';
import ShowSEOForm from '../../../Components/Forms/ShowSEOForm';
import StoryDetails from '../../../Components/Forms/StoryDetails';
import Sidebar from '../../../Components/base/sidebar';
import Delete from '../../../Components/Button/Delete';

export default function Gallery() {
    const location = useLocation();
    const id = location.state && location.state.id;
    const [image, setImage] = useState<File[]>([]);
    const [album_image, setImageAlbum] = useState<File | null>(null);
    const [post_date, setPostDate] = useState('');
    const [event_date_end, setEventDateEnd] = useState('');
    const [event_date_start, setEventDateStart] = useState('');
    const [folder_name, setFolderName] = useState('');
    const [album_name, setAlbumName] = useState('');
    const [album_code, setAlbumCode] = useState('');
    const [slug, setSlug] = useState('');
    const [category, setCategory] = useState('');
    const [isPermanent, setIsPermanent] = useState<boolean>(false);
    const [item, setItem] = useState<any | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [postID, setPostID] = useState<string | null>(null);
    const [role, setRole] = useState<string | null>(null);
    const [warningMessage, setWarningMessage] = useState<string>('');

    const MAX_FILE_SIZE_MB = 30;

    useEffect(() => {
        const id = location.state && location.state.id;
    }, []);

    const isValidTextFormat = (format: string) => /^[A-Za-z0-9-]+$/.test(format);

    const handleFolderNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        const newName = e.target.value;

        if (isValidTextFormat(newName) || newName === '') {
            setFolderName(newName);
        }
    };

    const handlePostDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPostDate(e.target.value);
    };

    const handleEventDateStartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEventDateStart(e.target.value);
    };

    const handleEventDateEndChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEventDateEnd(e.target.value);
    }

    const handleAlbumNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAlbumName(e.target.value);
    };

    const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setCategory(e.target.value);
    };

    const handleIsPermanentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsPermanent(e.target.checked);
    }

    const handleAlbumCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newName = e.target.value;

        if (isValidTextFormat(newName) || newName === '') {
            setAlbumCode(newName);
        }
    };

    const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newName = e.target.value;

        if (isValidTextFormat(newName) || newName === '') {
            setSlug(newName);
        }
    };


    const handleImageAlbum = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setImageAlbum(e.target.files[0]);
        }
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const selectedFiles = Array.from(e.target.files);
            const totalSize = selectedFiles.reduce((total, file) => total + file.size, 0);

            // Convert total size to MB
            const totalSizeInMB = totalSize / (1024 * 1024);

            // Check if the total size exceeds the limit
            if (totalSizeInMB > MAX_FILE_SIZE_MB) {
                setWarningMessage(`Warning: You can only upload up to ${MAX_FILE_SIZE_MB} MB of images. The selected files exceed this limit.`);
            } else {
                setWarningMessage('');
                setImage(selectedFiles);
            }
        }
    };


    const navigate = useNavigate();

    // const autosave = async () => {
    //     const formData = new FormData();
    //     formData.append('category', category);
    //     formData.append('sub_category', sub_category);
    //     formData.append('title', title);
    //     formData.append('body', body);
    //     formData.append('seo_title', seo_title);
    //     formData.append('seo_details', seo_details);
    //     formData.append('slug', slug);
    //     formData.append('sub_head', sub_head);
    //     formData.append('photo_by', photo_by);
    //     if (image) {
    //         formData.append('image', image);
    //     }
    //     if (imageUrl) {
    //         formData.append('imageUrl', imageUrl);
    //     }

    //     try {
    //         const authToken = localStorage.getItem('authToken');
    //         if (!authToken) {
    //             return;
    //         }

    //         if (postID) {
    //             await axios.post(`https://cdn.pulp.ph/api/v1/shortStory/save/${postID}`, formData, {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     Authorization: `Bearer ${authToken}`,
    //                 }

    //             }
    //             );
    //         } else {
    //             const response = await axios.post(`https://cdn.pulp.ph/api/v1/save/shortStory`, formData, {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     Authorization: `Bearer ${authToken}`,
    //                 }
    //             });
    //             setPostID(response.data.id);
    //         }

    //         setIsSaved(false);

    //     } catch (error) {
    //         console.error('Unable to Autosave Form!', error);
    //     } finally {
    //         setTimeout(() => {
    //             setIsSubmitting(false);
    //         }, 3000);
    //     }
    // };

    // useEffect(() => {
    //     const handler = setTimeout(() => {
    //         autosave();
    //     }, 2000);

    //     return () => {
    //         clearTimeout(handler);
    //     };
    // }, [category, sub_category, title, body, seo_title, seo_details, sub_head, photo_by, image, imageUrl]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('post_date', post_date);
        formData.append('folder_name', folder_name);
        formData.append('album_name', album_name);
        formData.append('album_code', album_code);
        formData.append('slug', slug);
        if (album_image) {
            formData.append('album_image', album_image);
        } else {
            formData.append('album_image', '');
        }

        if (image.length > 0) {
            image.forEach((image, index) => {
                formData.append(`image[${index}]`, image);
            });
        }

        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                alert('Authentication token not found!');
                setIsSubmitting(false);
                return;
            }

            if (postID) {
                await axios.post(`https://cdn.pulp.ph/v1/pulpliveworld/gallery/${postID}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${authToken}`,
                    }
                });
            } else {
                const response = await axios.post(`https://cdn.pulp.ph/api/v1/pulpliveworld/gallery`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${authToken}`,
                    }
                });
                setPostID(response.data.id);
            }
            alert('Content Submitted Successfully !!');
            navigate('/view/post/gallery');
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert(`All fields required`);
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        }
    };
    const handleViewShortstory = async () => {
        try {
            if (postID) {
                window.open(`https://pulpmagazine.com/article/${postID}`, '_blank');
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        setRole(storedRole);
    }, []);

    const handleDelete = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                // Handle the case where authToken is not available
                alert('Authentication token not found!');
                return;
            }

            const confirmDelete = window.confirm('Are you sure you want to delete this content?');
            if (!confirmDelete) {
                return; // If user cancels, do nothing
            };

            if (id) {
                await axios.delete(`https://cdn.pulp.ph/api/v1/pulpliveworld/gallery/${id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    }
                })
            };
            alert('Content Deleted Successfully !!');// Handle success (e.g., show a success message or redirect)
            navigate('/view/post/Show')
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            // Handle error (e.g., show an error message)
        }
    };

    return (
        <>
            <div className="w-full">
                <div className='Dashboard-container flex place-content-between'>
                    <h1 className='mt-5 font-semibold'>Gallery Editor</h1>
                    <ActionBar
                        role={role}
                        // onSave={handleSaveDraft}
                        onSubmit={handleSubmit}
                        onView={handleViewShortstory}
                        isSubmitting={isSubmitting}
                        isSaved={isSubmitting}
                    />
                </div>
                <div className='container mt-5 pt-5 px-4 rounded bg-white'>
                    <GalleryForm
                        image={image}
                        album_image={album_image}
                        onImageChange={handleImageChange}
                        onAlbumImageChange={handleImageAlbum}
                        post_date={post_date}
                        event_date_end={event_date_end}
                        event_date_start={event_date_start}
                        category={category}
                        isPermanent={isPermanent}
                        warningMessage={warningMessage}
                        slug={slug}
                        folder_name={folder_name}
                        album_code={album_code}
                        album_name={album_name}
                        onSlugChange={handleSlugChange}
                        onPostDateChange={handlePostDateChange}
                        onFolderNameChange={handleFolderNameChange}
                        onAlbumCodeChange={handleAlbumCodeChange}
                        onAlbumNameChange={handleAlbumNameChange}
                        onCategoryChange={handleCategoryChange}
                        onEventDateEndChange={handleEventDateEndChange}
                        onEventDateStartChange={handleEventDateStartChange}
                        onIsPermanentChange={handleIsPermanentChange}
                    />
                    <div className='w-full border-1 border-black rounded mb-5'> </div>

                    {/* onClick={() => handleDelete(item.id)} */}
                </div>
            </div>
        </>
    );
}
